<template>
    <v-container fluid>
        <v-layout wrap>
            <v-flex xs12 sm3>
                <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink>
                <v-btn v-if="selected.length > 1" color="error" @click.stop="checkConfirmDelete(selected)" :loading="deleting">
                    <span>Batch Delete</span>
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout pt-3>
            <v-flex xs12>
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :rows-per-page-items="rowsPerPageItems" 
                    :pagination.sync="pagination"
                    :search="search"
                    select-all
                    item-key="JobID"
                    :loading="loadingJobs"
                    :items="nuPointSprayJobs">
                    <template v-slot:headers="props">
                        <tr>
                            <th>
                            <v-checkbox
                                :input-value="props.all"
                                :indeterminate="props.indeterminate"
                                primary
                                hide-details
                                @click.stop="toggleAll"
                            ></v-checkbox>
                            </th>
                            <th
                            v-for="header in props.headers"
                            :key="header.text"
                            :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                            @click="changeSort(header.sortable, header.value)"
                            >
                            <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                            {{ header.text }}
                            </th>
                        </tr>
                    </template>
                    <template v-slot:items="props">
                        <tr :active="props.selected" @click="props.selected = !props.selected">
                            <td>
                                <v-checkbox
                                    :input-value="props.selected"
                                    primary
                                    hide-details
                                ></v-checkbox>
                            </td>                      
                            <td>{{ props.item.JobID }}</td>                        
                            <td>{{ props.item.JobStatus }}</td>
                            <td>{{ props.item.Plant }}</td>
                            <td>{{ props.item.Location }}</td>
                            <td>{{ props.item.FarmName }}</td>
                            <td>{{ props.item.FieldName }}</td>
                            <td>{{ props.item.ScheduledStart | formatDateTime }}</td>
                            <td>{{ props.item.ScheduledEnd | formatDateTime    }}</td>
                            <td>{{ props.item.ActualStart | formatDateTime }}</td>
                            <td>{{ props.item.ActualEnd | formatDateTime }}</td>
                            <td>{{ props.item.WithHoldEnd | formatDateTime }}</td>
                            <td>
                                <v-layout row>
                                    <v-btn 
                                        color="primary"
                                        block 
                                        class="mr-2"
                                        @click.stop="openEdit(props.item)">
                                        <span>Edit</span>
                                    </v-btn>
                                    <v-btn color="error" block @click.stop="checkConfirmDelete([props.item])" :loading="deleting">
                                        <span>Delete</span>
                                    </v-btn>
                                </v-layout>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <v-dialog :value="jobsToDelete != null" max-width="290" persistent @keydown.esc="cancelDelete">
                    <v-card>
                        <v-toolbar>
                            <v-toolbar-title>Confirm Delete</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <span>Are you sure you want to delete?</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="cancelDelete">Cancel</v-btn>
                            <v-btn color="error" @click="confirmDelete" :loading="deleting">Delete</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" :value="editJobID" persistent @keydown.esc="cancelEdit">
                    <NuPointSprayJobEdit @cancel="cancelEdit" @saved="saved" :jobID="editJobID"></NuPointSprayJobEdit>
                </v-dialog>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import nuPointSprayApi from '@/api/nuPointSprayApi';
import NuPointSprayJobEdit from '@/components/nuPointSpray/NuPointSprayJobEdit.vue';

export default {
    components: {
        NuPointSprayJobEdit
    },
    data() {
        return {            
            deleting: false,
            search: '',
            selected: [],
            rowsPerPageItems: [10, 25, 50, 100],
            jobsToDelete: null,
            editJobID: null,
            pagination: {
                page: 1,
                rowsPerPage: 25,
                descending: true,
                sortBy: "ScheduledStart"
            },
            headers: [
                {
                    text: "Job ID",
                    value: "JobID",
                    sortable: true
                },
                {
                    text: "Job Status",
                    value: "JobStatus",
                    sortable: true
                },
                {
                    text: "Plant",
                    value: "Plant",
                    sortable: true
                },
                {
                    text: "Location",
                    value: "Location",
                    sortable: true
                },
                {
                    text: "Farm Name",
                    value: "FarmName",
                    sortable: true
                },
                {
                    text: "Farm Field",
                    value: "FieldName",
                    sortable: true
                },
                {
                    text: "Scheduled Start",
                    value: "ScheduledStart",
                    sortable: true
                },
                {
                    text: "Scheduled End",
                    value: "ScheduledEnd",
                    sortable: true
                },
                {
                    text: "Actual Start",
                    value: "ActualStart",
                    sortable: true
                },
                {
                    text: "Actual End",
                    value: "ActualEnd",
                    sortable: true
                },
                {
                    text: "WithHold End",
                    value: "WithHoldEnd",
                    sortable: true
                },
                {
                    text: "Actions",
                    value: "",
                    sortable: false
                }
            ]
        }
    },
    computed: {
        ...mapState("NuPointSprayStore", [
            "loadingJobs",            
            "error",
            "nuPointSprayJobs"
        ])
    },
    methods: {
        ...mapActions("NuPointSprayStore", [
            "searchNuPointSprayJobs"
        ]),
        openEdit(item) {
            this.editJobID = item.JobID;
        },
        checkConfirmDelete(ids) {
            this.jobsToDelete = ids;
        },
        cancelDelete() {
            this.finishConfirmDelete();
        },
        cancelEdit() {
            this.editJobID = null;
        },
        saved() {
            this.editJobID = null;
            this.searchNuPointSprayJobs();
        },
        async confirmDelete() {
            await this.deleteItems(this.jobsToDelete);
            
            this.finishConfirmDelete();
        },
        finishConfirmDelete() {
            this.jobsToDelete = null;
        },
        async deleteItems(jobs) {
            var ids = jobs.map(x => x.JobID);
            this.deleting = true;

            var result = await nuPointSprayApi.deleteJobs(ids);
            
            var errorMessage = null;
            if (!result.Success) {
                errorMessage = result.ErrorMessages.join(', ');
            } else {
                // splice the items from the data
                for (var i = 0; i < ids.length; i++) {
                    var index = this.nuPointSprayJobs.findIndex(x => x.JobID === ids[i]);
                    if (index >= 0) {
                        this.nuPointSprayJobs.splice(index, 1);
                    }
                }
            }
            this.$emit("deleteComplete", errorMessage);

            this.deleting = false;
        },
        toggleAll () {
            if (this.selected.length) this.selected = []
            else this.selected = this.nuPointSprayJobs.slice()
        },
        changeSort (sort, column) {
            if (sort) {
                if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending
                } else {
                this.pagination.sortBy = column
                this.pagination.descending = false
                }
            }
        }
    }
}
</script>